import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { GiveawayBrandFrame } from '../components/GiveawayBrandFrame';
import { giveawayApi } from '../lib/giveaway-api';

export default function GiveawayRules() {
  const { slug } = useParams();
  const [brand, setBrand] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => { giveawayApi(`/giveaway/${slug}`).then(data => setBrand(data.brand)).catch(err => setError(err.message)); }, [slug]);
  return <GiveawayBrandFrame brand={brand}>
    <h1 data-testid="giveaway-rules-title">Official Rules</h1>
    {brand ? <>
      {!brand.rules_published && <p className="giveaway-notice" data-testid="giveaway-rules-draft">Draft placeholder — final Official Rules have not been published. Entries are not open yet.</p>}
      <div className="giveaway-rules" data-testid="giveaway-rules-content">{brand.rules_text || `Official Rules for ${brand.name} will appear here before the giveaway opens. Final eligibility, winner count, drawing dates, prize terms, and sponsor information will be provided by the restaurant.`}</div>
      <Link to={`/giveaway/${slug}`} className="giveaway-link" data-testid="giveaway-rules-back-link">Back to giveaway</Link>
    </> : <p data-testid="giveaway-rules-loading">{error || 'Loading rules…'}</p>}
  </GiveawayBrandFrame>;
}